import firebase from "firebase";  
var firebaseConfig = {  
    /* 
    replace this object with yours 
    */  
   apiKey: "AIzaSyDj_d9VCyhcBeDe3vFiLl-FBV-6WYFqeK8",
  authDomain: "easycryptocoins-4cdc6.firebaseapp.com",
  databaseURL: "https://easycryptocoins-4cdc6-default-rtdb.firebaseio.com/",
  projectId: "easycryptocoins-4cdc6",
  storageBucket: "easycryptocoins-4cdc6.appspot.com",
  messagingSenderId: "29931606331",
  appId: "1:29931606331:web:d348a168fefb0cbac6a71e",
  measurementId: "G-VL77ZPRVR6"  
};  
  
// Initialize Firebase  
var firebaseDb = firebase.initializeApp(firebaseConfig);  
  
export default firebaseDb.database().ref();